import { render, staticRenderFns } from "./PageOrdersEvent.vue?vue&type=template&id=d3a86f50&"
import script from "./PageOrdersEvent.vue?vue&type=script&lang=js&"
export * from "./PageOrdersEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3a86f50')) {
      api.createRecord('d3a86f50', component.options)
    } else {
      api.reload('d3a86f50', component.options)
    }
    module.hot.accept("./PageOrdersEvent.vue?vue&type=template&id=d3a86f50&", function () {
      api.rerender('d3a86f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ordersEvent/PageOrdersEvent.vue"
export default component.exports